// Contas da tela de Vendas na Visão Geral (#6497): Júlia, Thayla e Valdo.
//
// - Quanto falta para a meta, por dia útil: o que falta de kWh aprovado ÷ os
//   dias úteis (seg–sex) que ainda restam no mês, contando hoje.
// - Relógio do SLA dos leads novos: tempo útil desde a atribuição contra o limite
//   do bônus de SLA do Comercial Interno (média até 7 min úteis, comissaoInterna.ts).
//
// Lógica pura. Feriados não entram na conta de dias úteis (como em `diasUteisDoMes`).

/** Limite do SLA de primeiro contato do Comercial Interno, em minutos úteis. */
export { INTERNO_SLA_LIMIAR_MIN as LIMITE_SLA_MIN } from '../comissaoInterna.ts';

/** Dias úteis (seg–sex) de `hoje` até o fim do mês, contando hoje. */
export function diasUteisRestantes(hoje: Date): number {
  const ultimo = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).getDate();
  let n = 0;
  for (let d = hoje.getDate(); d <= ultimo; d++) {
    const dia = new Date(hoje.getFullYear(), hoje.getMonth(), d).getDay();
    if (dia !== 0 && dia !== 6) n++;
  }
  return n;
}

export interface RitmoDaMeta {
  /** kWh que ainda faltam (0 quando a meta já foi batida). */
  falta: number;
  /** kWh por dia útil até o fim do mês; null sem dia útil sobrando. */
  porDia: number | null;
  diasUteis: number;
  /** Fração da meta já aprovada (1 = bateu). */
  atingido: number;
}

/** Quanto falta para a meta e o ritmo diário que fecha o mês nela. Sem meta, null. */
export function ritmoParaMeta(aprovado: number, meta: number | null | undefined, hoje: Date): RitmoDaMeta | null {
  if (!meta || meta <= 0) return null;
  const falta = Math.max(0, meta - aprovado);
  const diasUteis = diasUteisRestantes(hoje);
  return {
    falta,
    porDia: falta === 0 ? 0 : diasUteis > 0 ? falta / diasUteis : null,
    diasUteis,
    atingido: aprovado / meta,
  };
}

/** "8 min", "1 h 05", "3 dias" — para o relógio do SLA e o tempo médio. */
export function duracaoCurta(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return '—';
  const min = Math.max(0, Math.round(ms / 60_000));
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  if (h < 48) return `${h} h ${String(min % 60).padStart(2, '0')}`;
  return `${Math.floor(h / 24)} dias`;
}
